import React from 'react';
import HeyDayPNG from '../assets/icons/heyday-medicBox.svg';
import hotDoc from '../assets/icons/hotDoc.svg';
import { ConsultationIcon } from '../assets/svgImages';
import ClickToAction from './CTA';

const BookConsultationButton: React.FC = () => {
  const theme = process.env.VITE_THEME_TOGGLE;

  const buttonImg =
    theme === 'HeyDay' ? (
      <img src={HeyDayPNG} alt="HeyDay" className="w-7" />
    ) : theme === 'MedReleaf' ? (
      <img src={hotDoc} alt="MedReleaf" className="w-7" />
    ) : (
      <ConsultationIcon />
    );

  const href =
    theme === 'HeyDay'
      ? 'https://bookings.heydaymedical.com.au/doctors'
      : theme === 'MedReleaf'
        ? 'https://www.hotdoc.com.au/medical-centres/telehealth/medreleaf-clinics/doctors'
        : 'https://automedsystems.com.au/ams/clinics/5675/atlus-surry-hills-2010/doctors/a/';

  return (
    <ClickToAction
      buttonText="book consultation"
      className="rounded-lg shadow bg-secondary-green-50 text-secondary-green-700 px-8 py-2.5 text-lg font-semibold w-full md:w-80"
      buttonImg={buttonImg}
      href={href}
    />
  );
};

export default BookConsultationButton;
